import UserTable from "../table/usertable";
import EmployeeTable from "../table/employeetable";
import Account from "../../context/acount";
import { useContext } from "react";
import { permission_type } from "../../constants";
export default function Table() {
  const { control } = useContext(Account);
  if (!control) return "Loading....";
  return (
    <div>
      {/*!control[permission_type.VIEW_EMPLOYEE_LIST] &&
        !control[permission_type.VIEW_USER_LIST] && (
          <p className="font-Roboto text-xl font-bold m-auto text-center">Nothing to show</p>
        )*/}
       <UserTable />
      <EmployeeTable />
    </div>
  );
}
